import React, { useState, useEffect } from 'react';
import { Flex, Box } from 'rebass';
import { HeaderSubnavLink } from 'components/Header/HeaderSubnavLink';
import { HeaderSubnavButton } from 'components/Header/HeaderSubnavButton';
import { SmallLink } from 'components/Header/SmallLink';
import H1 from 'components/H1';
import { Link } from 'react-router-dom';
import cache from 'utils/cache';
import helpers from 'utils/helpers';
import moment from 'moment-timezone';
import analytics from 'utils/analytics';
import { FiLayers, FiFileText, FiCalendar, FiSettings, FiPieChart, FiMail } from 'react-icons/fi';
import SideOverlay from 'components/SideOverlay';
import services from 'services/services';
import service_studies from 'services/studies';
import { useToasts } from 'react-toast-notifications';
import classNames from 'classnames';
import ItemWrapper from 'components/ItemWrapper';
import useQuery from 'hooks/useQuery';

moment.locale('ultra-short-relative', {
    relativeTime: {
        future: 'in %s',
        past: '%s', //removed "ago"
        s: '%dsec',
        ss: '%dsec',
        m: '1min',
        mm: '%dmin',
        h: '1hr',
        hh: '%dhr',
        d: '1d',
        dd: '%dd',
        w: '1wk',
        ww: '%dwk',
        M: '1mo',
        MM: '%dmo',
        y: '1yr',
        yy: '%dyr'
    }
});

function StudyActivity(props) {
    const { addToast } = useToasts();

    const { data: activity, isLoading } = useQuery({
        queryFn: async () => service_studies.getStudyActivity(props.study_id),
        onError: error => {
            const errorText = services.parseAndTrackXhrErrors(error);
            addToast(errorText, {
                appearance: 'error',
                autoDismiss: true
            });
        }
    });

    function renderNoActivity() {
        return (
            <Box px={4} py={3}>
                No activity yet.
            </Box>
        );
    }

    function renderActivity() {
        try {
            const formatted_activities = [];

            if (!activity) {
                return renderNoActivity();
            }

            if (activity.email_received && Array.isArray(activity.email_received)) {
                activity.email_received.forEach(a => {
                    formatted_activities.push({
                        created_at: a.date_received,
                        message: a.text_body,
                        person: a.person,
                        study_person_id: a.study_person_id,
                        comm_type: 'E-mail'
                    });
                });
            }

            if (activity.sms_received && Array.isArray(activity.sms_received)) {
                activity.sms_received.forEach(a => {
                    formatted_activities.push({
                        created_at: a.created_at,
                        message: a.message,
                        person: a.person,
                        study_person_id: a.study_person_id,
                        comm_type: 'SMS'
                    });
                });
            }

            formatted_activities.sort((a, b) => moment(b.created_at) - moment(a.created_at));

            if (formatted_activities.length == 0) {
                return renderNoActivity();
            }

            return (
                <Box>
                    {formatted_activities.map((a, index) => {
                        return (
                            <Link
                                to={`/studies/${props.study_id}/participants/${a.study_person_id}`}
                                onClick={e => {
                                    if (props.onClickParticipant) {
                                        props.onClickParticipant({ id: a.study_person_id });
                                        e.preventDefault();
                                    } else {
                                        console.log('ho');
                                    }
                                }}
                            >
                                <ItemWrapper className={classNames(index == 0 && 'border-top-gray')}>
                                    <Flex sx={{ justifyContent: 'space-between', width: '100%' }}>
                                        <Box className="color-text-primary" sx={{ flexGrow: 1 }}>
                                            <b>{helpers.personGetFullName(a.person)}</b> replied via {a.comm_type}:
                                            <br />
                                            <div className="ellipsis">{a.message}</div>
                                        </Box>
                                        <Box sx={{ width: '80px', flexGrow: 1, textAlign: 'right' }} className="fs-12">
                                            {moment(a.created_at)
                                                .locale('ultra-short-relative')
                                                .fromNow()}
                                        </Box>
                                    </Flex>
                                </ItemWrapper>
                            </Link>
                        );
                    })}
                </Box>
            );
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <SideOverlay
            onClose={() => {
                props.onClose();
            }}
        >
            <Box px={4} py={3}>
                <H1 style={{ marginBottom: '0' }}>Activity</H1>
            </Box>
            {isLoading ? (
                <Box px={4} py={3}>
                    Loading...
                </Box>
            ) : (
                renderActivity()
            )}
        </SideOverlay>
    );
}

export default StudyActivity;
